import { t } from "@redotech/redo-i18n";
import { Condition as ModelCondition } from "@redotech/redo-return-core-common/return-flow/condition";
import { VendorMatchType } from "@redotech/redo-return-core-common/return-flow/condition-enums";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import {
  validateVendorCondition,
  vendorFromModel,
  type VendorState,
} from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const VENDOR = (
  Details: React.ComponentType<ConditionTypeDetailsProps<VendorState>>,
): ConditionType<VendorState, ModelCondition.Vendor> => ({
  name: CONDITION_NAMES[ModelCondition.VENDOR],
  description(state) {
    const vendors = state.vendors.join(", ");
    switch (state.matchType) {
      case VendorMatchType.ALL:
        return t("All items match vendors: {{vendors}}", { vendors });
      case VendorMatchType.ANY:
        return t("Any item matches vendors: {{vendors}}", { vendors });
      case VendorMatchType.NONE:
        return t("No items match vendors: {{vendors}}", { vendors });
      case VendorMatchType.ITEM:
        return t("Vendors: {{vendors}}", { vendors });
    }
  },
  Details(props: ConditionTypeDetailsProps<VendorState>) {
    return React.createElement(Details, props);
  },
  empty: { vendors: [], matchType: VendorMatchType.ITEM },
  fromModel(model: ModelCondition.Vendor) {
    return vendorFromModel(model);
  },
  toModel(state) {
    return {
      type: ModelCondition.VENDOR,
      vendors: state.vendors,
      matchType:
        state.matchType === VendorMatchType.ITEM ? undefined : state.matchType,
    };
  },
  valid(state) {
    return validateVendorCondition(state).valid;
  },
});
